import { Directive, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appFocusOut]'
})
export class FocusOutDirective {

  @Output() elementFocusOut = new EventEmitter();

  @HostListener('document:click', ['$event.target']) onFocusOut(targetElement): any {
    const checkClick = this.el.nativeElement.contains(targetElement);
    if (!checkClick) {
      this.elementFocusOut.emit();
    }
  }

  constructor(private el: ElementRef) { }
}
